export default "__VITE_ASSET__uwF1gpZh__"